<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getMovements"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'pallets-movements-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-2">#</div>
        <div class="col-md-2">Type</div>
        <div class="col-md-2">Branch</div>
        <div class="col-md-2">Supplier</div>
        <div class="col-md-3">References</div>
        <div class="col-md-1"></div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-2">
          <strong>{{ slotProps.item.pallet_movement_number }}</strong>
          /
          <span class="text-black-50 font-weight-normal">
            {{
              moment(new Date(slotProps.item.created_at)).format("DD MMM YY")
            }}
          </span>
        </div>
        <div class="col-md-2 font-weight-bold">
          <p
            v-if="slotProps.item.type == 'Return to supplier'"
            class="text-info"
          >
            Returned
          </p>
          <p
            v-if="slotProps.item.type == 'Receive from supplier'"
            class="text-warning"
          >
            Received
          </p>
          <p v-if="slotProps.item.type == 'Inter branch transfer'">Transfer</p>
        </div>
        <div class="col-md-2">
          <span class="badge badge-primary" v-if="slotProps.item.from_branch">{{
            slotProps.item.from_branch.code
          }}</span>

          <i
            class="lni lni-arrow-right mx-1"
            v-if="slotProps.item.type == 'Inter branch transfer'"
          ></i>

          <span class="badge badge-info" v-if="slotProps.item.to_branch">{{
            slotProps.item.to_branch.code
          }}</span>
        </div>
        <div class="col-md-2">
          <span v-if="slotProps.item.from_supplier">{{
            slotProps.item.from_supplier.name
          }}</span>
          <span v-if="slotProps.item.to_supplier">{{
            slotProps.item.to_supplier.name
          }}</span>
        </div>
        <div class="col-md-3">
          <span v-if="slotProps.item.invoice_number">
            {{ slotProps.item.invoice_number }}
          </span>
          /
          <span v-if="slotProps.item.gkn_number">
            {{ slotProps.item.gkn_number }}
          </span>
        </div>
        <div class="col-md-1 text-right">
          <span v-if="slotProps.item.has_discrepancy == 1">
            <i class="lni lni-warning text-danger mr-1"></i>
          </span>
          <span
           class="text-info table-action-icon"
            @click="
              selectedMovement = slotProps.item;
              movementDetailToggle = true;
            "
          >
            <i class="lni lni-search-alt"></i>
          </span>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'pallets-movements' })"
      :lazy="true"
    >
      <router-view
        @palletMovementCreated="palletMovementCreated()"
        @movementReceived="palletMovementReceived()"
      ></router-view>
    </b-modal>

    <b-modal
      :hide-footer="true"
      title="Movement Details"
      size="lg"
      v-model="movementDetailToggle"
      v-if="selectedMovement != null"
      @hidden="update"
    >
      <template #modal-header>
        <div class="row">
          <div class="col-auto">
            <span class="bg-primary text-white px-3 py-1">{{
              selectedMovement.pallet_movement_number
            }}</span>
          </div>
          <div class="col">
            <h4 class="m-0">
              {{ selectedMovement.type }}

              <span
                class="badge badge-warning mx-2"
                v-if="selectedMovement.status == 'In Progress'"
                >In Progress</span
              >
            </h4>
          </div>
        </div>

        <button
          type="button"
          class="close"
          @click="movementDetailToggle = false"
        >
          X
        </button>
      </template>

      <div class="row">
        <div class="col-12">
          <div
            v-if="
              selectedMovement.status == 'In Progress' && userHasBranchAccess()
            "
            class="mb-3"
          >
            <span
              v-b-tooltip.hover
              title="Receive"
              @click="receiveMovement"
              class="btn btn-success m-0"
            >
              Receive Transfer <i class="lni lni-arrow-down-circle"></i>
            </span>
          </div>
          <table class="table table-sm">
            <table-row label="Created" :noBorder="true">
              {{
                moment(new Date(selectedMovement.created_at)).format(
                  "DD MMM YY, HH:mm"
                )
              }}
            </table-row>

            <table-row label="Received At" v-if="selectedMovement.received_at">
              {{
                moment(new Date(selectedMovement.received_at)).format(
                  "DD MMM YY, HH:mm"
                )
              }}
            </table-row>

            <table-row
              label="Sent"
              class="font-weight-bold"
              v-if="selectedMovement.type == 'Inter branch transfer'"
              >{{ selectedMovement.debit }}
            </table-row>
            <table-row
              label="Received"
              class="font-weight-bold"
              v-if="
                selectedMovement.type == 'Receive from supplier' ||
                selectedMovement.type == 'Inter branch transfer'
              "
              >{{ selectedMovement.credit }}
            </table-row>
            <table-row
              label="Returned"
              class="font-weight-bold"
              v-if="selectedMovement.type == 'Return to supplier'"
              >{{ selectedMovement.debit }}
            </table-row>

            <table-row label="From" v-if="selectedMovement.from_branch"
              >{{ selectedMovement.from_branch.name }}
            </table-row>

            <table-row label="Sender" v-if="selectedMovement.from_branch"
              >{{ selectedMovement.sender.name }}
            </table-row>

            <table-row label="From" v-if="selectedMovement.from_supplier"
              >{{ selectedMovement.from_supplier.name }}
            </table-row>

            <table-row label="To" v-if="selectedMovement.to_supplier"
              >{{ selectedMovement.to_supplier.name }}
            </table-row>

            <table-row label="To" v-if="selectedMovement.to_branch"
              >{{ selectedMovement.to_branch.name }}
            </table-row>

            <table-row
              label="Invoice Number"
              v-if="selectedMovement.type == 'Receive from supplier'"
              >{{ selectedMovement.invoice_number }}
            </table-row>
            <table-row
              label="GKN Number"
              v-if="selectedMovement.type == 'Receive from supplier'"
              >{{ selectedMovement.gkn_number }}
            </table-row>

            <table-row
              label="Receiver"
              v-if="
                selectedMovement.to_branch &&
                selectedMovement.status == 'Completed'
              "
              >{{ selectedMovement.receiver.name }}
            </table-row>

            <table-row label="Remark">{{ selectedMovement.remark }} </table-row>
          </table>

          <b-button
            v-if="!isPrinting"
            @click="
              print(
                selectedMovement.id,
                selectedMovement.pallet_movement_number
              )
            "
            variant="info"
          >
            <i class="lni lni-printer"></i> Print
          </b-button>
        </div>
        <span v-if="isPrinting">Printing...</span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import palletRepo from "@/api/repos/palletRepo";
import dataTable from "@/components/common/DataTable";
import tableRow from "@/components/common/TableRow";

export default {
  components: {
    dataTable: dataTable,
    tableRow,
  },

  data() {
    return {
      sidebarToggle: false,
      isPrinting: false,
      isLoad: false,
      sort: { column: "created_at", label: "Date Created Desc", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
        { column: "gkn_number", label: "GKN Number Asc", order: "asc" },
        { column: "gkn_number", label: "GKN Number Desc", order: "desc" },
        { column: "invoice_number", label: "Invoice Number Asc", order: "asc" },
        {
          column: "invoice_number",
          label: "Invoice Number Desc",
          order: "desc",
        },
      ],
      filterOptions: [],
      filters: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      branches: [],
      suppliers: [],
      lastPage: 0,
      items: [],
      movementDetailToggle: false,
      selectedMovement: null,
    };
  },
  mounted() {
    this.getMovements({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });

  },
  methods: {

    async getFilterData() {
      let { data } = await palletRepo.branches();
      this.branches = data.branches
       let x = await palletRepo.suppliers();
      this.suppliers = x.data.suppliers



      this.filterOptions.push({
        column: "group-heading",
        label: "type",
      });

      this.filterOptions.push({
        column: "type",
        value: "Inter branch transfer",
        label: "Inter branch transfer",
      });

      this.filterOptions.push({
        column: "type",
        value: "Receive from supplier",
        label: "Receive from supplier",
      });

      this.filterOptions.push({
        column: "type",
        value: "Return to supplier",
        label: "Return to supplier",
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "from branch",
      });

      data.branches.forEach((p) => {
        this.filterOptions.push({
          column: "from_branch_id",
          value: p.id,
          label: "from: "+p.name,
        });
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "to branch",
      });

      data.branches.forEach((p) => {
        this.filterOptions.push({
          column: "to_branch_id",
          value: p.id,
          label: "to: "+p.name,
        });
      });

       this.filterOptions.push({
        column: "group-heading",
        label: "from supplier",
      });



      this.suppliers.forEach((p) => {
        this.filterOptions.push({
          column: "from_supplier_id",
          value: p.id,
          label: "from: "+p.name,
        });
      });

       this.filterOptions.push({
        column: "group-heading",
        label: "to supplier",
      });

      this.suppliers.forEach((p) => {
        this.filterOptions.push({
          column: "to_supplier_id",
          value: p.id,
          label: "to: "+p.name,
        });
      });
    },

    async getMovements(e) {
      this.isLoad = true;
      try {
        let { data } = await palletRepo.movements(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.sort = e.sort
        this.filters = e.filters != null ? e.filters : null

        this.items = data.movements.data;
        this.totalRows = data.movements.total;
        this.page = data.movements.current_page;
        this.fromRow = data.movements.from;
        this.toRow = data.movements.to;
        this.lastPage = data.movements.last_page;

        this.filterOptions = [];

        this.getFilterData();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    receiveMovement() {
      this.movementDetailToggle = false;
      this.$router.push({
        name: "pallets-movements-received",
        params: { id: this.selectedMovement.id },
      });
    },

    async print(id, number) {
      this.isPrinting = true;

      try {
        let response = await palletRepo.movementPrint(id);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `pallet_movement_${number}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.isPrinting = false;
      }
    },

    async update() {
      this.getMovements(
        {
          sort: this.sort,
          filters: this.filters,
          page: this.page,
          rowsPerPage: localStorage.getItem("rowsPerPage")
            ? localStorage.getItem("rowsPerPage")
            : 12,
          search: "",
        },
        true
      );
    },

    palletMovementCreated() {
      this.$bvToast.toast("Movement Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getMovements({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    palletMovementReceived() {
      this.$bvToast.toast("Transfer Received", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getMovements({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    userHasBranchAccess() {
      let r = false;

      this.branches.forEach((b) => {
        if (b.id == this.selectedMovement.to_branch_id) {
          r = true;
        }
      });

      return r;
    },

    getReturnedTotal() {
      let c = 0;

      this.selectedMovement.details.forEach((d) => (c += d.debit));

      return c;
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
